var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Verification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-Verification",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7178",
    "data-name": "Rectangle 7178",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "verification-symbol-svgrepo-com",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17362",
    "data-name": "Group 17362"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10988",
    "data-name": "Path 10988",
    d: "M18.518,5.695a4.923,4.923,0,0,0-1.447-2.766,4.923,4.923,0,0,0-2.765-1.447A3.153,3.153,0,0,1,12.979.933,4.925,4.925,0,0,0,10,0,4.925,4.925,0,0,0,7.021.933a3.156,3.156,0,0,1-1.326.549A4.923,4.923,0,0,0,2.929,2.929,4.923,4.923,0,0,0,1.482,5.695,3.15,3.15,0,0,1,.933,7.021,4.924,4.924,0,0,0,0,10a4.924,4.924,0,0,0,.933,2.979A3.148,3.148,0,0,1,1.482,14.3a4.923,4.923,0,0,0,1.447,2.766,4.923,4.923,0,0,0,2.765,1.447,3.156,3.156,0,0,1,1.326.549A4.924,4.924,0,0,0,10,20a4.925,4.925,0,0,0,2.979-.933,3.156,3.156,0,0,1,1.326-.549A5.225,5.225,0,0,0,18.518,14.3a3.15,3.15,0,0,1,.549-1.326A4.923,4.923,0,0,0,20,10a4.923,4.923,0,0,0-.933-2.979A3.147,3.147,0,0,1,18.518,5.695ZM16.374,6.726,9.188,13.912l-1.15,1.15a.813.813,0,0,1-1.15,0l-1.15-1.15L3.626,11.8a.813.813,0,0,1,0-1.15L4.776,9.5a.813.813,0,0,1,1.15,0l1.537,1.537,6.611-6.611a.813.813,0,0,1,1.15,0l1.15,1.15A.813.813,0,0,1,16.374,6.726Z",
    fill: "#02466a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Verification);
export default __webpack_public_path__ + "static/media/icon-24-Verification.af233775f86b38c30a3b76ade00dee13.svg";
export { ForwardRef as ReactComponent };